import { LicenseDetailsSheet } from "@/components/dashboard/license-details-sheet";
import type { UserType } from "@/constants";
import {
  getLicenseTypeQuestionsOptions,
  getNonRegistrantLicenseCommentsOptions,
  getNonRegistrantLicensePaymentsOptions,
} from "@/hera-api/client/@tanstack/react-query.gen";
import { useLicenseDetailsWithRuntimeRefresh } from "@/hooks/use-license-details-with-runtime-refresh";
import { useQuery } from "@tanstack/react-query";

export function StrLinkedLicenseSheet({
  licenseId,
  onLicenseIdChange,
  userType,
}: {
  licenseId: string | null;
  onLicenseIdChange: (licenseId: string | null) => void;
  userType: UserType;
}) {
  const licenseQuery = useLicenseDetailsWithRuntimeRefresh({
    licenseId,
    enabled: licenseId != null,
  });
  const commentsQuery = useQuery({
    ...getNonRegistrantLicenseCommentsOptions({
      path: { license_id: licenseId ?? "" },
    }),
    enabled: licenseId != null,
  });
  const paymentsQuery = useQuery({
    ...getNonRegistrantLicensePaymentsOptions({
      path: { license_id: licenseId ?? "" },
    }),
    enabled: licenseId != null,
  });
  const questionsQuery = useQuery({
    ...getLicenseTypeQuestionsOptions({
      path: {
        license_type_id: licenseQuery.licenseData?.license_type?.id ?? "",
        jurisdiction_id: licenseQuery.licenseData?.jurisdiction?.id ?? "",
      },
    }),
    enabled: Boolean(
      licenseQuery.licenseData?.license_type?.id &&
        licenseQuery.licenseData?.jurisdiction?.id,
    ),
  });

  return (
    <LicenseDetailsSheet
      isOpen={licenseId != null}
      onOpenChange={(open) => {
        if (!open) onLicenseIdChange(null);
      }}
      isSelectedLicenseLoading={licenseQuery.isPreviewLoading}
      isAdditionalQuestionsQueryLoading={questionsQuery.isLoading}
      selectedLicenseError={licenseQuery.previewError}
      additionalQuestionsQueryError={questionsQuery.error}
      additionalQuestions={questionsQuery.data}
      selectedLicenseData={licenseQuery.licenseData}
      commentsData={commentsQuery.data}
      isCommentsQueryLoading={commentsQuery.isLoading}
      commentsQueryError={commentsQuery.error}
      paymentsData={paymentsQuery.data}
      isPaymentsQueryLoading={paymentsQuery.isLoading}
      userType={userType}
      isLicenseRuntimeRefreshing={licenseQuery.isRuntimeRefreshing}
    />
  );
}
